import React from 'react';
import styled from 'styled-components';

export default function FilterApplyButton({ text = 'Apply', onClick }) {
	return (
		<Container className='filter-apply-buttons' onClick={onClick}>
			<Text>{text}</Text>
		</Container>
	);
}

const Container = styled.div`
	background: var(--more-button-bg-color);
	border: none;
	border-radius: 2px;
	padding: 7px;
	font-family: 'NotoSansB';
	font-weight: 700;
	font-size: 12px;
	text-align: center;
	width: 100%;
`;

const Text = styled.span`
	color: var(--text-color);
`;
